document.addEventListener('DOMContentLoaded', () => {
    const counter = document.querySelector('.count');
    if (counter) {
        window.addEventListener("load", function () {
            setTimeout(function () {
                const numCountElements = document.querySelectorAll(".count");

                const observerOptions = {
                    root: null, // relative to the viewport
                    rootMargin: '-30% 0px', // Adjust the offset to target the middle of the screen on scroll
                    threshold: 0 // The element just needs to enter this area to trigger
                };

                const countUp = (spanElement, duration) => {
                    const target = +spanElement.getAttribute("data-count");
                    let count = 0;

                    // Adjust the increment based on the target value and dynamic duration
                    const increment = target / (duration / 16); // 16ms per frame for 60 FPS

                    const updateCount = () => {
                        count += increment;
                        spanElement.textContent = Math.floor(count);

                        if (count < target) {
                            requestAnimationFrame(updateCount);
                        } else {
                            spanElement.textContent = target; // Ensure final value is set correctly
                        }
                    };

                    updateCount();
                };

                const startCounting = (wrapper) => {
                    const spans = wrapper.querySelectorAll('.count');
                    const maxNumber = Math.max(...Array.from(spans).map(span => +span.getAttribute('data-count')));

                    spans.forEach(span => {
                        span.textContent = "0"; // Reset to 0 for counting

                        // Set a base duration for the largest number
                        const baseDuration = 2000; // 2 seconds for the largest number
                        const targetNumber = +span.getAttribute('data-count');
                        const duration = (targetNumber / maxNumber) * baseDuration; // Duration proportional to the number size

                        countUp(span, duration);
                    });
                };

                const handleIntersection = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            startCounting(entry.target);
                            observer.unobserve(entry.target); // Stop observing once animation starts
                        }
                    });
                };

                const observer = new IntersectionObserver(handleIntersection, observerOptions);

                // Observe each parent of .num-count elements
                numCountElements.forEach(numCount => {
                    const parent = numCount.parentElement; // Get the parent of the .num-count element
                    observer.observe(parent); // Observe the parent element

                    // Immediate check if the element is already visible on page load
                    const rect = parent.getBoundingClientRect();
                    if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
                        const span = parent.querySelector('.count');
                        startCounting(parent);
                        observer.unobserve(parent); // Stop observing once counting has started
                    }
                });
            }, 500);
        });
    }

    // const section = document.querySelector('.counter');
    // if (section) {
    //     const bgGradient = section.querySelector('.bg-gradient');
    //     const items = section.querySelectorAll('.item');

    //     // Define the reference screen height and scroll speeds
    //     const referenceHeight = 985;
    //     const referenceScrollSpeeds = [-7, 9, 25];

    //     // Function to calculate dynamic scroll speeds
    //     function getScrollSpeeds() {
    //         const currentHeight = window.innerHeight; // Get the current screen height
    //         const scalingFactor = currentHeight / referenceHeight; // Calculate scaling factor

    //         // Return dynamically adjusted scroll speeds
    //         return referenceScrollSpeeds.map(speed => speed * scalingFactor);
    //     }

    //     function handleScroll() {
    //         const scrollPos = window.scrollY;
    //         const height = window.innerHeight;
    //         const windowWidth = window.innerWidth;
    //         const scrollSpeeds = getScrollSpeeds(); // Get the dynamically adjusted scroll speeds

    //         items.forEach((item, index) => {
    //             if (window.innerWidth > 767) {  // Apply styles only if window width is greater than 767px
    //                 const parent = item.parentNode;
    //                 const parentRect = parent.getBoundingClientRect();
    //                 const parentHeight = parentRect.height;
    //                 const parentTop = parentRect.top;

    //                 let translate;
    //                 if (windowWidth > 991) {
    //                     translate = (parentTop - height) / scrollSpeeds[index];
    //                 } else {
    //                     translate = (parentTop - height) / scrollSpeeds[index]; // Adjust speed for each item
    //                 }

    //                 // Only apply the transformation if the item is in the viewport
    //                 if (parentTop < height && parentTop > height / 3) {
    //                     item.style.transform = `translate3d(0, ${translate}px, 0)`;
    //                 }
    //             } else {
    //                 // Reset styles if window width is less than or equal to 767px
    //                 item.style.transform = '';
    //             }
    //         });
    //     }

    //     // Run the function on scroll
    //     window.addEventListener('scroll', handleScroll);

    //     // Run the function initially to set styles correctly based on the current window size
    //     handleScroll();

    //     // Optionally, run handleScroll on window resize to recalculate scroll speeds and positions
    //     window.addEventListener('resize', handleScroll);
    // }

});
